module.exports = __webpack_public_path__ + "img/nuls.3a5447ba.svg";